export const NAIRA_WALLET_STATE_VALUES = [
  "KANO",
  "LAGOS",
  "KADUNA",
  "KATSINA",
  "OYO",
  "RIVERS",
  "BAUCHI",
  "JIGAWA",
  "BENUE",
  "ANAMBRA",
  "BORNO",
  "DELTA",
  "NIGER",
  "IMO",
  "AKWA_IBOM",
  "OGUN",
  "SOKOTO",
  "ONDO",
  "OSUN",
  "KOGI",
  "ZAMFARA",
  "ENUGU",
  "KEBBI",
  "EDO",
  "PLATEAU",
  "ADAMAWA",
  "CROSS_RIVER",
  "ABIA",
  "EKITI",
  "KWARA",
  "GOMBE",
  "YOBE",
  "TARABA",
  "EBONYI",
  "NASARAWA",
  "BAYELSA",
  "FCT",
] as const;

export type NairaWalletStateValue = (typeof NAIRA_WALLET_STATE_VALUES)[number];

export const formatNairaWalletStateLabel = (value: string): string =>
  value
    .split("_")
    .map((part) => part.charAt(0) + part.slice(1).toLowerCase())
    .join(" ");

export const NAIRA_WALLET_STATE_OPTIONS = NAIRA_WALLET_STATE_VALUES.map(
  (value) => ({
    value,
    label: formatNairaWalletStateLabel(value),
  })
);
